import { Sparkles, Trash2 } from 'lucide-react';

import { Button } from 'components/ui/button';
import { getSkillDisplayName, type SkillListItem } from 'pages/skills/skills.types';

type AgentConfigSkillCardProps = {
  skill: Pick<SkillListItem, 'id' | 'name' | 'displayName' | 'description' | 'iconUrl'>;
  onRemove: (skillId: string) => void;
  disabled?: boolean;
};

export function AgentConfigSkillCard({
  skill,
  onRemove,
  disabled = false,
}: AgentConfigSkillCardProps) {
  return (
    <div
      className={`flex min-w-0 items-center justify-between gap-3 rounded-lg border p-4 ${disabled ? 'opacity-50' : ''}`}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {skill.iconUrl ? (
          <img
            src={skill.iconUrl}
            alt=""
            className="h-10 w-10 flex-shrink-0 rounded object-cover"
          />
        ) : (
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded bg-primary/10">
            <Sparkles className="h-5 w-5" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <div className="truncate font-medium text-foreground">{getSkillDisplayName(skill)}</div>
          <div className="line-clamp-1 text-sm text-muted-foreground">
            {skill.description || 'No description'}
          </div>
        </div>
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={() => onRemove(skill.id)}
        disabled={disabled}
        className="shrink-0 text-muted-foreground hover:text-destructive disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
